import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import UTTag from '../../../../../../../../../../components/UTTag';

import styles from './styles';

function NormalDetail({ title, value, style, rateValueStyle, nullRateValueStyle, status }) {
  const customRateStyle = value ? rateValueStyle : nullRateValueStyle;
  return (
    <div style={[styles.container, style]}>
      <UTLabel semibold>{title}</UTLabel>
      <div style={[styles.valueContainer, !title && styles.noTitle, rateValueStyle && customRateStyle]}>
        {value && (
          <UTLabel darkGray light style={styles.detailValue}>
            {value}
          </UTLabel>
        )}
        {status && <UTTag>{status}</UTTag>}
      </div>
    </div>
  );
}

NormalDetail.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  status: PropTypes.string,
  rateValueStyle: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  nullRateValueStyle: PropTypes.any // eslint-disable-line react/forbid-prop-types
};

export default Radium(NormalDetail);
